var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-navbar'),_c('div',{staticClass:"container-fluid"},[(_vm.dataLoaded)?[_c('router-view')]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }